import { AxiosInstance } from 'axios';
import {
  BillingInfoRequestSchema,
  PaymentOperationBody,
  PaymentType,
  StartFreeTrialBody,
  SubscriptionPriceType,
  SubscriptionType,
} from 'store/subscription/types';

export const subscription = (ApiClient: () => Promise<AxiosInstance>) => {
  return {
    getSubscription: async () =>
      (await ApiClient()).get<SubscriptionType>('/subscription/customer'),
    getPaymentList: async () =>
      (await ApiClient()).get<PaymentType[]>('/payments/card/list'),
    setPaymentDefault: async (body: PaymentOperationBody) =>
      (await ApiClient()).post('/payments/card/default', body),
    deletePaymentMethod: async (id: string) =>
      (await ApiClient()).delete(`/payments/card/${id}`),
    getPriceList: async () =>
      (await ApiClient()).get<SubscriptionPriceType[]>('/prices/list'),
    getClientSecret: async () =>
      (await ApiClient()).get<{
        client_secret: string;
      }>('/payments/card/setup'),
    startFreeTrial: async (body: StartFreeTrialBody) =>
      (await ApiClient()).post('/subscription/start_free_trial', body),
    renewSubscription: async (body: StartFreeTrialBody) =>
      (await ApiClient()).post('/subscription/renew', body),
    upgradeSubscription: async (subscriptionId: string, newPriceId: string) =>
      (await ApiClient()).put<SubscriptionType>(
        `/subscription/plan/${subscriptionId}`,
        {},
        {
          params: {
            new_price_id: newPriceId,
          },
        },
      ),
    resumeSubscription: async (subscriptionId: string) =>
      (await ApiClient()).put<SubscriptionType>(`/subscription/resume/${subscriptionId}`),
    cancelSubscription: async (subId: string) =>
      (await ApiClient()).put<SubscriptionType>(`/subscription/cancel/${subId}`),
    updateBillingInfo: async (body: BillingInfoRequestSchema) =>
      (await ApiClient()).post('/payments/address', body),
  };
};
